import { PermissionScope, type PermissionScopeEnum } from "@fitness-app/data-models";

export const canFilterByTrainer = (permissionScope: PermissionScopeEnum): boolean =>
  permissionScope === PermissionScope.TEAM || permissionScope === PermissionScope.ALL;
